import axios from 'axios';

// 创建axios实例
const instance = axios.create({
  baseURL: process.env.VUE_APP_API_URL || '',
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json'
  }
});

// 请求拦截器
instance.interceptors.request.use(
  config => {
    // 可以在这里添加认证信息等
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// 响应拦截器
instance.interceptors.response.use(
  response => {
    return response.data;
  },
  error => {
    return Promise.reject(error);
  }
);

// 获取本地动作列表
export const getLocalActions = () => {
  return [
    { 
      id: 1, 
      name: 'yu', 
      requiredImages: 2,
      creditCost: 10,
      actionFile: 'yu.atn'
    }
  ];
};

// 验证图片链接（模拟）
export const validateImageUrl = (url) => {
  return new Promise((resolve, reject) => {
    // 简单验证URL格式
    // const isValidUrl = /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/.test(url);
    // if (!isValidUrl) {
    //   reject(new Error('图片链接格式不正确'));
    //   return;
    // }

    // 创建图片元素来验证链接是否可访问
    const img = new Image();
    img.onload = () => {
      resolve({
        url: url,
        isValid: true
      });
    };
    img.onerror = () => {
      reject(new Error('无法加载图片，请检查链接是否有效'));
    };
    img.src = url;
  });
};

// 以下保留但不再使用
export const uploadImage = (file) => {
  return new Promise((resolve) => {
    // 模拟上传成功，返回URL
    setTimeout(() => {
      resolve({
        url: URL.createObjectURL(file),
        filename: file.name
      });
    }, 500);
  });
};

export default instance; 